import { render, staticRenderFns } from "./BulletinArticleComponent.vue?vue&type=template&id=027bbb9b&scoped=true&"
import script from "./BulletinArticleComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinArticleComponent.vue?vue&type=style&index=0&id=027bbb9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027bbb9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027bbb9b')) {
      api.createRecord('027bbb9b', component.options)
    } else {
      api.reload('027bbb9b', component.options)
    }
    module.hot.accept("./BulletinArticleComponent.vue?vue&type=template&id=027bbb9b&scoped=true&", function () {
      api.rerender('027bbb9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinArticleComponent.vue"
export default component.exports